module.exports = __webpack_public_path__ + "img/portaal-beeldmerk.d227fe3c.png";